import type { SVGProp } from './types';

export const logo = (props: SVGProp) => (
  <svg width="200" height="45" viewBox="0 0 202 45" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" {...props}>
    <path
      d="M22.7775 43.5549c11.4751 0 20.7775-9.3024 20.7775-20.7775 0-11.4751-9.3024-20.77746-20.7775-20.77746C11.3024 1.99994 2 11.3023 2 22.7774c0 11.4751 9.3024 20.7775 20.7775 20.7775Z"
      stroke="currentColor"
      strokeWidth="2.28479"
      strokeMiterlimit="10"
    />
    <path
      d="M22.7606 24.331c.7674 0 1.3895-.6221 1.3895-1.3895 0-.7674-.6221-1.3896-1.3895-1.3896-.7674 0-1.3895.6222-1.3895 1.3896 0 .7674.6221 1.3895 1.3895 1.3895Z"
      fill="currentColor"
    />
    <g clipPath="url(#clip0_796_31928)">
      <path
        d="M60.7109 30.4669V14.8161h5.2118c2.0868 0 4.0511.8148 5.5259 2.2913 1.4768 1.4785 2.2887 3.443 2.2887 5.5341 0 2.0911-.8139 4.0557-2.2887 5.5342-1.4768 1.4785-3.4391 2.2912-5.5259 2.2912h-5.2118Zm5.2118-1.9563c1.5666 0 3.0373-.6106 4.1449-1.7195 1.1077-1.1089 1.7176-2.5833 1.7176-4.1496 0-1.5663-.6099-3.0407-1.7176-4.1496-1.1076-1.1089-2.5803-1.7194-4.1449-1.7194h-3.2576v11.7381h3.2576Z"
        fill="currentColor"
      />
      <path
        d="M96.7449 28.7475c-1.1076-1.1089-1.7176-2.5833-1.7176-4.1496v-9.7818h1.9542v9.7818c0 1.0455.4059 2.0278 1.1443 2.767.7385.7393 1.7196 1.1457 2.7642 1.1457 1.044 0 2.025-.4064 2.764-1.1457.738-.7392 1.144-1.7215 1.144-2.767v-9.7818h1.954v9.7818c0 1.5683-.61 3.0407-1.717 4.1496-1.108 1.1088-2.581 1.7194-4.145 1.7194-1.5647 0-3.0375-.6106-4.1451-1.7194Z"
        fill="currentColor"
      />
      <path
        d="M139.544 28.3292c-1.518 1.5193-3.535 2.3566-5.681 2.3566-2.146 0-4.161-.8373-5.681-2.3566-1.518-1.5194-2.354-3.539-2.354-5.6853 0-2.1463.836-4.168 2.354-5.6873 1.518-1.5194 3.535-2.3566 5.681-2.3566 2.146 0 4.161.8372 5.681 2.3566l-1.381 1.3825c-1.148-1.1497-2.674-1.7828-4.3-1.7828-1.626 0-3.149.6331-4.3 1.7828-1.148 1.1497-1.781 2.6772-1.781 4.3048 0 1.6276.633 3.153 1.781 4.3048 1.148 1.1497 2.674 1.7828 4.3 1.7828 1.626 0 3.15-.6331 4.3-1.7828l1.381 1.3825v-.002Z"
        fill="currentColor"
      />
      <path d="M201.998 16.7725h-4.885v13.6944h-1.954V16.7725h-4.886v-1.9564h11.725v1.9564Z" fill="currentColor" />
      <path
        d="m156.09 30.5755 6.933-15.8652h1.981l6.933 15.8652H156.09Zm12.896-1.8052-4.973-11.3787-4.972 11.3787h9.945Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_796_31928">
        <rect width="141.287" height="16.0858" fill="currentColor" transform="translate(60.7109 14.6003)" />
      </clipPath>
    </defs>
  </svg>
);
